import { TRPCClientError } from "@trpc/client";

// What the merchant needs to be told after a failed `submit`.
export type SubmitFailure =
  | "quoteChanged"
  | "screeningsUnavailable"
  | "keyReused"
  | "unknown";

// The codes are the backend's (protect/data/induction.ts, thrown as
// ConflictError(code)) and reach us as the error message. The portal only
// imports types from the backend, so they are repeated here. Anything else,
// including a timeout, leaves the outcome unknown.
export const submitFailure = (error: unknown): SubmitFailure => {
  if (!(error instanceof TRPCClientError)) return "unknown";

  switch (error.message) {
    case "QUOTE_CHANGED":
      return "quoteChanged";
    case "SCREENINGS_UNAVAILABLE":
      return "screeningsUnavailable";
    case "IDEMPOTENCY_KEY_REUSED":
      return "keyReused";
    default:
      return "unknown";
  }
};
